import React from 'react';
import './Footer.css';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MailIcon from '@mui/icons-material/Mail';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div className='container-fluid ' id='footer'>
     <div className="row logo-row">
        <h1>&nbsp;</h1>
     </div>
     <hr />
     <div className="row content-row">
        <div className="col left-col">
            <img src="img-data/logo-white.png" alt=".." style={{height:"9rem"}} />
            <hr />
            <p>Our products are based on latest technologies and requirements by customer. Unique has build on this strong foundation over the past years, signifying reliability, quality and value for money.</p>
        </div>
        <div className="col middle-col">
            <h3>Our Services</h3>
            <hr />
            <p><b>&gt;</b>Solar Services</p>
            <p><b>&gt;</b>Street Light Automation System</p>
            <p><b>&gt;</b>Tube Well/Pump Automation System</p>
            <p><b>&gt;</b>Flow Meter with Remote Monitoring System</p>
            <p><b>&gt;</b>Application Software Development</p>
            <p><b>&gt;</b>PCL, HMI, Drive & SCADA</p>
        </div>
        <div className="col right-col">
            <h3>Contact Us</h3>
            <hr />
            <p> <LocationOnIcon/> <b>Corporate Office :</b> B-102,Sector 64 <br /> &nbsp;, Noida - 201301
            <br />
            <LocationOnIcon/> <b>Factory</b> :Plot no. 29, MUP 1, <br /> Ecotech 3, Gautam Budh Nagar, <br /> Greater Noida-201306 (U.P.). </p>
            <p><MailIcon/> d.pandey@uniqutechnologies.com </p>
            <p><LocalPhoneIcon/> +91-9999044355</p>
        </div>
     </div>
     <hr />
     <div className="row bottom-row">
        <div className="col left-col">
        © Copyright 2024 . All Rights Reserved. | <b>Unique Technologies</b>
        </div>
        <div className="col right-col">
            <div className="row">
                <Link to="https://www.facebook.com/uniquete?mibextid=ZbWKwL" target="_blank" rel="noopener noreferrer" className="col social-links" ><FacebookIcon/></Link>
                <Link className="col social-links"><LinkedInIcon/></Link>
                <Link className="col social-links"><XIcon/></Link>
            </div>
        </div>
     </div>
    </div>
  )
}

export default Footer
